<template>
  <FloatingBar
    v-if="hasAiAddon && isCurrentItemOwner"
    v-show="!isFloatingBarClosed && !isPlaying"
    :trial="isAiAddonTrial"
    :info_icon="isTranscriptionEmpty && !isStillProcessing"
    @close="isFloatingBarClosed = true"
    @trial-click="onTrialClick"
  >
    <template #message>
      <span v-if="isStillProcessing" class="message">Zight AI is processing your video.</span>
      <span v-else-if="isTranscriptionEmpty" class="message">No voice detected</span>
      <span v-else class="message"
        >Zight AI updated your content <a href="#" data-testid="floating-bar-ai-link" @click.prevent="scrollToDescription()">below</a>.</span
      >
    </template>
  </FloatingBar>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useStorage } from '@vueuse/core';
import { FloatingBar } from '@/storybook/floatingbar';
import { useSmartActionsStore } from '@/modules/viewer/store/useSmartActionsStore';
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useVideoAi } from '@/modules/viewer/composables/useVideoAi';
import { useUser } from '@/modules/viewer/composables/useUser';
import { computed } from 'vue';

const isFloatingBarClosed = useStorage('video-floating-bar-closed', false);
const smartActionsStore = useSmartActionsStore();
const transcriptionStore = useTranscriptionStore();
const viewerItemStore = useViewerItemStore();
const { isAiAddonTrial, hasAiAddon } = useVideoAi();
const { isCurrentItemOwner } = useUser();

const { isProcessing } = storeToRefs(smartActionsStore);
const { isTranscriptionProcessing, isTranscriptionEmpty } = storeToRefs(transcriptionStore);

const { currentVideoIsPlaying: isPlaying, isEditProcessing } = storeToRefs(viewerItemStore);

const isStillProcessing = computed(() => isProcessing.value || isTranscriptionProcessing.value || isEditProcessing.value);
const onTrialClick = () => {
  window.location.assign('/account/plans');
};
const scrollToDescription = () => {
  const description = document.querySelector('[data-testid="viewer-description"]');
  if (description) {
    description.scrollIntoView({ behavior: 'smooth' });
  }
};
</script>
<style scoped>
.message a {
  @apply underline;
}
</style>
